import "./about.scss";

export default function About() {
  return (
    <>
      <section className="section about-section">
        <div className="container about-container">
          <div className="flex about-flex">
            <h1>Welcome to SKY Taekwondo!</h1>
            <p>
              We founded SKY Taekwondo with one goal in mind: giving our
              students the best, most rewarding learning experience. <br />
              <br />
              Embracing the core principles of Taekwondo's Five Tenets -
              integrity, perseverance, self-control, indomitable spirit, and
              respect - we offer a vibrant community dedicated to not just
              mastering martial arts techniques, but also fostering invaluable
              life skills. <br /> <br />
              Our experienced instructors cater to all skill levels, guiding
              individuals to embody these values on and off the training floor.
              We are located in two locations, Basking Ridge and Clinton NJ.
              Join us at Sky Taekwondo to embark on a journey of self-discovery,
              resilience, and personal growth through the art of Taekwondo.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
